
import PropTypes from 'prop-types';
import styled from 'styled-components';

import Section from './Section';
import devices from '@/utilities/devices';

const SplitSectionContainer = styled.div`
  display: flex;
  align-items: ${props => props.alignItems === 'top' ? 'flex-start' : 'center'};
  height: 100%;
  width: 100%;
  position: relative;
  @media screen and (${devices.mobile}) {
    flex-direction: ${props => props.columnReversed ? 'column-reverse' : 'column'};
    padding: 4em 0 0em;
  }
  @media screen and (${devices.minTablet}) and (${devices.maxTablet}) {
    flex-direction: ${props => props.columnReversed ? 'column-reverse' : 'column'};
  }

  > div {
    width: 100%;
    display: flex;
    align-items: flex-start;
    flex-direction: column;
    :first-child {
      width: ${props => props.firstWidth}%;
      @media screen and (${devices.mobile}) {
        width:100%;
        align-items: center;
        justify-content: center;
      }
      @media screen and (${devices.minTablet}) and (${devices.maxTablet}) {
        width:100%;
        align-items: center;
        justify-content: center;
      }
    }

    :nth-child(2) {
      width: ${props => props.secondWidth}%;
      @media screen and (${devices.mobile}) {
        width: 100%;
      }
      @media screen and (${devices.minTablet}) and (${devices.maxTablet}) {
        width: 100%;
      }
    }

    :nth-child(3) {
      width: ${props => props.thirdWidth}%;
      @media screen and (${devices.mobile}) {
        width: 100%;
      }
      @media screen and (${devices.minTablet}) and (${devices.maxTablet}) {
        width: 100%;
      }
    }

    :nth-child(4) {
      width: ${props => props.fourthWidth}%;
      @media screen and (${devices.mobile}) {
        width: 100%;
      }
      @media screen and (${devices.minTablet}) and (${devices.maxTablet}) {
        width: 100%;
      }
    }

    :last-child {
      width: ${props => props.fithWidth}%;
      @media screen and (${devices.mobile}) {
        width: 100%;
      }
      @media screen and (${devices.minTablet}) and (${devices.maxTablet}) {
        width: 100%;
      }
    }
  }
`;

const SplitSection = ({
	className, children, scrollTo, firstWidth, secondWidth, thirdWidth, fourthWidth, fithWidth,
	columnReversed, bgColor, bgImage, fixedHeight, alignItems,
}) => {
	return (
		<Section className={className} scrollTo={scrollTo} bgColor={bgColor} bgImage={bgImage} fixedHeight={fixedHeight}>
			<SplitSectionContainer
				firstWidth={firstWidth}
				secondWidth={secondWidth}
				thirdWidth={thirdWidth}
				fourthWidth={fourthWidth}
				fithWidth={fithWidth}
				columnReversed={columnReversed}
				alignItems={alignItems}
			>
				{children}
			</SplitSectionContainer>
		</Section>
	);
};

SplitSection.propTypes = {
	className: PropTypes.any,
	children: PropTypes.any,
	scrollTo: PropTypes.object,
	firstWidth: PropTypes.number,
	secondWidth: PropTypes.number,
	thirdWidth: PropTypes.number,
	fourthWidth: PropTypes.number,
	fithWidth: PropTypes.number,
	columnReversed: PropTypes.bool,
	bgColor: PropTypes.string,
	bgImage: PropTypes.string,
	fixedHeight: PropTypes.bool,
	alignItems: PropTypes.string,
};

export default SplitSection;
